import React from 'react';
import { Link, NavLink } from 'react-router-dom';

export default function Navbar() {
  return (
    <nav className="nav">
      <div className="nav-inner">
        <Link to="/" className="nav-brand" aria-label="RUNIC Solutions Home">
          <img src="/RUNICLogo.png" alt="RUNIC logo" className="nav-logo" />
          <span className="nav-title">RUNIC</span>
        </Link>
        <ul className="nav-links" role="menubar">
          <li role="none">
            <NavLink to="/" end role="menuitem" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Home</NavLink>
          </li>
          <li role="none">
            <NavLink to="/about" role="menuitem" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>About</NavLink>
          </li>
          <li role="none">
            <NavLink to="/rd" role="menuitem" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>R&amp;D</NavLink>
          </li>
          <li role="none">
            <NavLink to="/tome" role="menuitem" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Tome</NavLink>
          </li>
          <li role="none">
            <NavLink to="/yummers" role="menuitem" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Yummers</NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
}
